export function cardsCarousel() {
	document.querySelectorAll('.splide--carousel').forEach(carousel => {
		const list = carousel.querySelector('.splide__list')
		if (!list) return

		const items = Array.from(list.querySelectorAll('.splide__slide'))
		const prevBtn = carousel.querySelector('.splide__arrow--prev')
		const nextBtn = carousel.querySelector('.splide__arrow--next')
		const total = items.length

		if (total < 2) return

		// Assign initial data-pos: 0 = center, 1 = right, 2 = far right (hidden), -1 = left, etc.
		items.forEach((item, i) => {
			item.dataset.pos = i <= Math.floor(total / 2) ? i : i - total
		})

		function getPos(current, active) {
			const diff = current - active
			if (Math.abs(diff) > Math.floor(total / 2)) {
				return diff > 0 ? diff - total : diff + total
			}
			return diff
		}

		function shift(direction) {
			items.forEach(item => {
				item.dataset.pos = getPos(parseInt(item.dataset.pos), direction)
			})
			updateHeight()
		}

		function updateHeight() {
			const active = list.querySelector('.splide__slide[data-pos="0"]')
			if (active) list.style.height = active.offsetHeight + 'px'
		}

		prevBtn?.addEventListener('click', () => shift(-1))
		nextBtn?.addEventListener('click', () => shift(1))

		window.addEventListener('resize', updateHeight)

		requestAnimationFrame(updateHeight)
	})
}
